module.exports = __webpack_public_path__ + "f97da6d458722b30e6c91259707c4b8c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/nail-polish.png
// module id = 2691
// module chunks = 0